module.exports = {
    init : () => {
        document.addEventListener('facetwp-loaded', function() {
            let pagerLinks = document.querySelectorAll('.facetwp-page');
            pagerLinks.forEach(link => {
                link.addEventListener('click', () => {
                    window.scrollTo({top: 100});
                });
            });
        });
    }   
};